import { Injectable } from '@angular/core';
import * as XLSX from 'xlsx';
import { Observable } from 'rxjs';
import { AppTokenHandler } from '../common/app-token-handler';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { saveAs } from 'file-saver';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

declare global {
    interface Navigator {
      msSaveBlob?: (blob: any, defaultName?: string) => boolean;
    }
  }


@Injectable({
    providedIn: 'root'
  })


  
export class ExcelService {

    constructor(private appToken: AppTokenHandler,
        private router: Router, private location: Location) { }

    public exportAsExcelFile(json: any, excelFileName: string): void {
        const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
        console.log('worksheet', worksheet);
        const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
        XLSX.writeFile(workbook, excelFileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION, { bookType: 'xlsx', type: 'buffer' });
    }

    public ExportExcel(url: any, ReportName: any): Observable<any> {
        let xhr: any;
        return Observable.create(observer  => {
            xhr = new XMLHttpRequest();
            xhr.onreadystatechange = () => {
                if (xhr.readyState === 4) {
                    if (xhr.status === 200) {
                        if (navigator.appVersion.toString().indexOf('.NET') > 0) {
                            window.navigator.msSaveBlob(xhr.response, ReportName + '_' + Date.now() + '.xls');
                     
                            // const blob = new Blob([xhr.response], { type: 'application/vnd.ms-excel' });
                            // saveAs(blob, `${ReportName}_${Date.now()}.xls`);
                            // observer.next();
                            // observer.complete();
                    
                    
                    
                     
                        const blob = new Blob([xhr.response], { type: 'application/vnd.ms-excel' });
                        saveAs(blob, `${ReportName}_${Date.now()}.xls`);
                        xhr = null;
                         } else {
                            const blobURL = window.URL.createObjectURL(xhr.response);
                            const anchor = document.createElement('a');
                            anchor.download = ReportName + '_' + Date.now() + '.xls';
                            anchor.href = blobURL;
                            anchor.click();
                        }
                        xhr = null;
                    } else {
                        observer.error(xhr.response);
                        this.router.navigate(['/error/2']);
                    }
                }
            };
            xhr.open('GET', url);
            xhr.setRequestHeader('AUTHA', this.appToken.getSessionToken());
            xhr.withCredentials = true;
            xhr.responseType = 'blob'; // Get a binary response
            xhr.send();
        });

    }

    // public ExportExcel(url: any, ReportName: any): Observable<any> {
    //     return new Observable(observer => {
    //       const xhr = new XMLHttpRequest();
    //       xhr.onreadystatechange = () => {
    //         if (xhr.readyState === 4) {
    //           if (xhr.status === 200) {
    //             const blob = new Blob([xhr.response], { type: 'application/vnd.ms-excel' });
    //             if (window.navigator && window.navigator.msSaveBlob) {
    //               // For IE
    //               window.navigator.msSaveBlob(blob, `${ReportName}_${Date.now()}.xls`);
    //             } else {
    //               // For other browsers
    //               const blobURL = window.URL.createObjectURL(blob);
    //               const anchor = document.createElement('a');
    //               anchor.download = `${ReportName}_${Date.now()}.xls`;
    //               anchor.href = blobURL;
    //               anchor.click();
    //               window.URL.revokeObjectURL(blobURL); // Clean up
    //             }
    //             observer.next();
    //             observer.complete();
    //           } else {
    //             observer.error(xhr.response);
    //             this.router.navigate(['/error/2']);
    //           }
    //         }
    //       };
    //       xhr.open('GET', url);
    //       xhr.setRequestHeader('AUTHA', this.appToken.getSessionToken());
    //       xhr.withCredentials = true;
    //       xhr.responseType = 'blob'; // Get a binary response
    //       xhr.send();
    //     });
    //   }
    // }
    

    public ExportExcelcallback(url: any, ReportName: any, callback) {
        let xhr: any;

        xhr = new XMLHttpRequest();
        xhr.onreadystatechange = () => {
            if (xhr.readyState === 4) {
                if (xhr.status === 200) {
                    if (navigator.appVersion.toString().indexOf('.NET') > 0) {
                        window.navigator.msSaveBlob(xhr.response, ReportName + '_' + Date.now() + '.xls');
                    } else {
                        const blobURL = window.URL.createObjectURL(xhr.response);
                        const anchor = document.createElement('a');
                        anchor.download = ReportName + '_' + Date.now() + '.xls';
                        anchor.href = blobURL;
                        anchor.click();
                    }
                    callback.apply(this, [false]);
                    xhr = null;
                } else {

                    this.router.navigate(['/error/2']);
                }
            }
        };
        xhr.open('GET', url);
        xhr.setRequestHeader('AUTHA', this.appToken.getSessionToken());
        xhr.withCredentials = true;
        xhr.responseType = 'blob'; // Get a binary response
        xhr.send();
    }

}
